module.exports = __webpack_public_path__ + "fonts/icofont.92adb3cf.woff";